import TimeSince from "components/TimeSince/TimeSince";
import { __callbacks } from "Utils/Callbacks/Callback";
import { ChatMessage } from "Utils/Chats/ChatMessage";
import { ChatMessageFragment } from "Utils/Chats/ChatMessageFragment";
import { __debug } from "Utils/Debug/Debug";
import { Chat } from "Utils/Enums";
import { __map } from "Utils/Map/Map";
import { __utils } from "Utils/Utils";
import React, { useCallback, useEffect, useState } from "react";
import Text from "../Text/Text";
import styles from "./MessageNotify.module.scss";
import { MessageNumber } from "components/ChatApp/components/Body/components/Utils/MessageNumber";

const components = {
    Text
};

export default function MessageNotify(props: any) {
    const [time,] = useState(props.time ?? Date.now());
    const [id,] = useState(props.id ?? __utils.getUuidv4());
    const [classGroup, setClassGroup] = useState("");
    const [childs, setChilds] = useState<any[]>([...props.children]);
    const [fragmentNo,] = useState(new MessageNumber());

    const getNewFragmentNo = useCallback(() => {
        const fragNo = fragmentNo.get();
        fragmentNo.increment();
        return fragNo;
    }, [fragmentNo]);

    const initListeners = useCallback(() => {
        // destory msg fragment callback
        __callbacks.msgFragmentEx.destroyCallback();

        if (props.local) return;

        const fragNo = getNewFragmentNo();
        __map.setFragmentNoOnId(props.children[0].props.id, fragNo);

        __callbacks.messageNotify.trigger({
            type: Chat.Message,
            data: new ChatMessage({
                id: id,
                chatId: props.conversationId,
                messageNo: props.messageNo,
                time: Date.now(),
                messageType: "MessageNotify",
                props: {},
                fragments: [
                    new ChatMessageFragment({
                        id: props.children[0].props.id ?? __utils.getUuidv4(),
                        chatId: props.conversationId,
                        messageNo: props.messageNo,
                        messageType: "MessageNotify",
                        fragmentType: props.children[0].props.type,
                        time: Date.now(),
                        props: props.children[0].props
                    })
                ]
            })
        });

        __callbacks.onMessageFragment((data: any) => {
            const { newChild } = data;

            // check the fragment message type
            if (newChild.messageType !== "MessageNotify") {
                __debug.warn(() => {
                    //console.warn("call empty method of the fragment! MessageNotify");
                });

                return __callbacks.messageFragment.destroyAndCallEmpty();
            }

            const newChildComponent = React.createElement((components as any)[newChild.fragmentType], { ...data.newChild.props });
            setChilds(arr => [...arr, newChildComponent]);

            __callbacks.messageNotify.trigger({
                type: Chat.Fragment,
                data: new ChatMessageFragment({
                    id: newChild.props.id ?? __utils.getUuidv4(),
                    chatId: props.conversationId,
                    messageNo: props.messageNo,
                    messageType: "MessageNotify",
                    fragmentType: newChild.fragmentType,
                    time: Date.now(),
                    props: newChild.props
                })
            });
        });
    }, [props, getNewFragmentNo, id]);

    useEffect(() => {
        initListeners();
    }, [initListeners]);

    useEffect(() => {
        if (childs.length > 1) setClassGroup(styles.group);
    }, [childs]);

    useEffect(() => {
        var delay = 0;
        if (props.local) return; //delay = 500;
        __callbacks.scrollToBottomChat.trigger({ delay });
    }, [childs, props.local]);

    return (
        <div className={styles.container}>
            {childs.map((child, index) => {

                return (
                    <div key={index} className={`${styles["container-msg"]} ${classGroup}`}>
                        <span className={styles["msg-fragment"]}>{child}</span>
                    </div>
                );
            })}
            <div key={childs.length} className={styles["container-status"]}>
                <span><TimeSince time={time}></TimeSince></span>,&nbsp;<span>seen</span>
            </div>
        </div>
    );
}
